<script>
import SettingsSection from '@/components/advancedSettings/SettingsSection.vue'
import GroupCodeIndex from '@/views/GroupCodeIndex.vue'
import GroupCodesImage from '@/assets/helpImages/Groupcodes.png'

export default {
  name: 'GroupCodes',
  components: { GroupCodeIndex, SettingsSection },
  props: ['value'],
  emits: ['input'],

  data() {
    return {
      groupCode: GroupCodesImage,
    }
  },
}
</script>

<template>
  <settings-section
    :full-width="true"
    label="Group codes"
    :value="value"
    hint-title="Group codes"
    @input="$emit('input', $event)"
  >
    <group-code-index v-if="value" :hide-title="true" />
    <template #content>
      <div class="content">
        <table>
          <tr>
            <td class="left-column">
              <p>
                <b>Group codes</b>
              </p>
              <p>
                With group codes it is possibly to categorize products into
                groups. The group codes can be used in the stacking process, so
                the related products will be stacked separately.
              </p>
              <p>
                Example: The products of the product groups batteries and food
                should be stacked separately.
              </p>
            </td>
            <td class="right-column">
              <img :src="groupCode" alt="Image Description" class="imgSize" />
            </td>
          </tr>
        </table>
      </div>
    </template>
  </settings-section>
</template>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
td {
  border: 1px solid black;
}
.left-column {
  width: 100%;
  background-color: white;
  padding: 2rem;
}
.right-column {
  width: 100%;
  text-align: center;
  background-color: white;
}

.imgSize {
  width: 500px;
}

.content {
  padding: 16px;
}
</style>
